import { CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE } from "../actionTypes/index"

export const memorizeSelectedPreference = (value) => dispatch => {
    dispatch({ type: CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE, payload: value });
}